const validate = require("../../node_modules/uuid/dist/validate")
const v4 = require("../../node_modules/uuid/dist/v4")
const NIL = require("../../node_modules/uuid/dist/nil")

module.exports = {
  validate: validate?.default || validate,
  v4: v4?.default || v4,
  NIL: NIL?.default || NIL,
}
